<template>
	<sf-button icon="square-plue" v-if="isButton_(scrId, 'AD')" :onClick="openModal">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/UploadForm/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		openModal() {
			this.UploadFormModalValue.flg = 'I';
			this.defaultAssign_({ key: 'UploadFormModal', value: true });
		}
	}
};
</script>
<style></style>
